import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 23 39",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 39\" id=\"icon-arrow-left\">\n    <path stroke=\"#1A1A1A\" stroke-width=\"2\" fill=\"none\" d=\"M20.317 1.73 2.457 19l17.86 17.269\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol